import { makeStyles } from '@material-ui/core/styles';
import { DSTheme } from '../../../styles/themes/types';

export default makeStyles((theme: DSTheme) => ({
  wrapper: {
    width: '630px',
    color: theme.palette.text.primary,
    padding: '32px',
    backgroundColor: theme.palette.background.elevation1,
    borderRadius: '16px',
    outline: 0,
    maxHeight: '100%',
    overflowY: 'auto',

    display: 'grid',
    gridGap: '32px',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '& i': {
      cursor: 'pointer',
    },
  },
  inputRow: {
    display: 'grid',
    gridGap: '32px',
    gridTemplateColumns: '248px 248px',

    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '266px 266px',
    },
  },
  platforms: {
    display: 'grid',
    gridGap: '32px',
  },
  platformButtons: {
    display: 'grid',
    gridGap: '24px',
    gridTemplateColumns: '80px 80px 80px',
  },
  select: {
    '& .MuiSelect-select:focus': {
      backgroundColor: 'inherit',
    },

    '& fieldset': {
      borderColor: theme.palette.text.primary,
      borderRadius: '16px',
    },

    '& label': {
      transform: 'translate(15px, -5.5px) scale(0.75)',
      color: theme.palette.text.primary,
    },
  },
}));
